import React from "react";
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table
} from '@material-ui/core';
import moment from 'moment';
export default class ComponentToPrint extends React.Component {
    render() {
        const supplierWiseGrnItemDetails = this.props.supplierWiseGrnItemDetails;
        const SearchData = this.props.SearchData;
        const supplierGrnDetail = this.props.supplierGrnDetail;
        const fromDate = this.props.fromDate;
        const toDate = this.props.toDate;
        
        return (
            <div>
                <h2><center><u>Supplier Wise GRN Item Detail Report</u></center></h2>
                <div>&nbsp;</div>
                <h3><center>{SearchData.groupName} - {SearchData.factoryName}</center></h3>
                <h3><center>Supplier: {SearchData.supplierName === undefined ? 'All Suppliers' : SearchData.supplierName}</center></h3>  
                <h3><center>From Date {moment(fromDate).format('').split('T')[0]} To Date { moment(toDate).format('').split('T')[0]}</center></h3>
                <div>
                    <Box minWidth={1050}>
                        <TableContainer >
                            <Table aria-label="caption table" style={{border:'1px solid #ccc', width: '99%', margin:'auto'}}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align={'left'}>Supplier Name</TableCell>
                                        <TableCell align={'center'}>Item catogory</TableCell>
                                        <TableCell align={'center'}>Item</TableCell>
                                        <TableCell align={'center'}>PO number</TableCell>
                                        <TableCell align={'center'}>Invoice number</TableCell>
                                        <TableCell align={'center'}>Invoice date</TableCell>
                                        <TableCell align={'center'}>Item receive date</TableCell>
                                        <TableCell align={'center'}>Quantity</TableCell>
                                        <TableCell align={'center'}>Unit price</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {supplierWiseGrnItemDetails.map((data, index) => (
                                        <TableRow key={index}>
                                            <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                 {data.supplierName}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.itemCatogory}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                 {data.item}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.purchaseOrderNumber}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.invoiceNumber}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.invoiceDate.split('T')[0]}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.itemReceivedDate.split('T')[0]}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.quantity}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {Number(data.unitPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </div>
                <div>&nbsp;</div>
                <h3><center>***** End of List *****</center></h3>
            </div>
        );

    }

}